module.exports = __webpack_public_path__ + "img/rocket.88600329.png";